import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAntLocale } from '@fuxi/eevee-hooks';
import classnames from 'classnames/bind';
import { ZH } from '@yaotai/common-utils';
import NeteaseImg from '@/assets/image/netease.png';
import NeteaseGameImg from '@/assets/image/netease-game.png';
import LeihuoImg from '@/assets/image/leihuo.png';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export function Footer() {
  const { t } = useTranslation();
  const { language } = useAntLocale();
  const renderList =
    language === ZH
      ? [
          { href: 'http://gb.corp.163.com/gb/about/overview.html', text: t('footer.aboutNetEase') },
          { href: 'http://help.163.com/', text: t('footer.privacyPolicy') },
          {
            href: 'https://static.fuxi.netease.com/yaotai/conference/20220309/1646802582497_ac9d725d.pdf',
            text: t('footer.contactNetEase'),
          },
          { href: 'http://game.163.com/about/', text: t('footer.careers') },
          { href: 'http://game.163.com/contact/', text: t('footer.ContactUs') },
          { href: 'http://game.163.com/contact/business.html', text: t('footer.businessCooperation') },
          { href: 'https://fuxi.163.com/recruitment', text: t('footer.joinUs') },
        ]
      : [
          { href: 'https://ir.netease.com/', text: t('footer.aboutNetEase') },
          { href: 'https://ir.netease.com/privacy-policy-terms-and-conditions', text: t('footer.privacyPolicy') },
          { href: 'https://ir.netease.com/shareholder-services/ir-contacts', text: t('footer.contactNetEase') },
          { href: 'https://hr.163.com/', text: t('footer.careers') },
        ];
  return (
    <>
      <div id="NIE-copyRight">
        <div className={cx('nie-copyright-new-inner')}>
          <div className={cx('nie-cn-part1')}>
            <span className={cx('nie-cn-logo')}>
              <a className={cx('a0')} href="http://www.163.com" target="_blank" rel="noopener noreferrer">
                <img src={NeteaseImg} alt="Netease" height="36" />
              </a>
              <a className={cx('a1')} href="http://game.163.com" target="_blank" rel="noopener noreferrer">
                <img src={NeteaseGameImg} alt="NeteaseGame" height="36" />
              </a>
              <a className={cx('a2')} href="http://leihuo.163.com" target="_blank" rel="noopener noreferrer">
                <img src={LeihuoImg} alt="Leihuo" height="36" />
              </a>
              <a className={cx('a3')} href="http://fuxi.163.com" target="_blank" rel="noopener noreferrer">
                <img
                  src="https://static.fuxi.netease.com/yaotai/portal/20220802/l6bzxgdv_615411.png"
                  alt="Fuxi"
                  height="38"
                />
              </a>
            </span>
            <span className={cx('nie-cn-nav')}>
              <i className={cx('nie-cn-nav-i1')}>
                {renderList.map((item, index) => (
                  <React.Fragment key={item.href}>
                    <a key={item.href} href={item.href} target="_blank" rel="noopener noreferrer">
                      {item.text}
                    </a>
                    {index + 1 !== renderList.length && '-'}
                  </React.Fragment>
                ))}
              </i>
              <br />
              <i className={cx('nie-cn-nav-i-text')}>
                {t('footer.copyright')} ©1997-{new Date().getFullYear()}
              </i>
              <br />
              {language === ZH && <i className={cx('nie-cn-nav-i-text')}>网易 (杭州) 网络有限公司</i>}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
